var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lazy-load"},[(_vm.show)?_vm._t("default"):_vm._e(),(!_vm.show)?_vm._t("tip",[_c('div',{class:[_vm.maskClass ? _vm.maskClass : 'lazy-load-mask'],domProps:{"innerHTML":_vm._s(_vm.tip)}})]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }